export default __webpack_public_path__ + "img/cadooz-logo.d34078a1.svg";